import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.875 19.25a.687.687 0 0 1-.688.688H4.812a1.376 1.376 0 0 1-1.375-1.375v-2.75a.687.687 0 0 1 1.375 0v2.75h1.375a.687.687 0 0 1 .688.687m0-17.187H4.812a1.377 1.377 0 0 0-1.375 1.374V5.5a.688.688 0 1 0 1.375 0V3.438h2.063a.687.687 0 1 0 0-1.376m11.688 5.5a.68.68 0 0 0-.208-.493l-4.806-4.806-.015-.013-.035-.032-.018-.014-.036-.026-.015-.01-.043-.025-.011-.005-.05-.024-.008-.003-.055-.02q-.004 0-.008-.002l-.057-.014-.018-.003-.049-.007-.069-.003h-2.75a.687.687 0 0 0 0 1.374h2.063v4.126a.69.69 0 0 0 .687.687h4.125v3.438a.688.688 0 0 0 1.375 0V7.576zm-.688 6.875a.687.687 0 0 0-.688.687v3.438H16.5a.687.687 0 1 0 0 1.375h.687a1.377 1.377 0 0 0 1.375-1.375v-3.438a.687.687 0 0 0-.687-.687m-13.75-1.376a.687.687 0 0 0 .687-.687V8.938a.687.687 0 1 0-1.375 0v3.437a.687.687 0 0 0 .688.688m8.937 5.5H9.625a.687.687 0 1 0 0 1.375h3.437a.687.687 0 1 0 0-1.375"
    }, null, -1)
  ])))
}
export default { render: render }